module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_5_5_2.acc67ca0.jpeg";